import {
  type ForManagerLocationDetail,
  getLocationsHomeAttentionRetrieveQueryOptions,
  getLocationsHomeLaterRetrieveQueryOptions,
} from "@sidegigllc/api/client";
import type { WarmableQuery } from "routing/warmQueries";
import { suspenseQuery } from "utils/suspenseQuery";

export type HomeSearch = { shifts_mine?: boolean; jobs_mine?: boolean };

type QueriesInput = { location: ForManagerLocationDetail; search: HomeSearch };

export const attentionQuery = ({ location, search }: QueriesInput) =>
  suspenseQuery(
    getLocationsHomeAttentionRetrieveQueryOptions(location.id, {
      shifts_mine: search.shifts_mine,
      jobs_mine: search.jobs_mine,
    }),
  );

export const laterQuery = ({ location }: Pick<QueriesInput, "location">) =>
  suspenseQuery(getLocationsHomeLaterRetrieveQueryOptions(location.id));

export const queries = (input: QueriesInput): Array<WarmableQuery> => [attentionQuery(input), laterQuery(input)];
